import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsIOrgEntity, MpsIRole, MpsIUser } from '../interfaces/mps-user.interface';

export class MpsUser implements MpsIUser {
  id!: number;
  firstname!: string;
  lastname!: string;
  email!: string;
  lang!: string;
  last_connection!: string;
  igg!: string;
  role_id!: number;
  org_entity_code?: string | null;
  delegation_start!: string | null;
  delegation_end!: string | null;

  role!: MpsRole;
  entities: MpsIOrgEntity[] = [];

  constructor(data = {}) {
    Object.assign(this, data);
  }

  isAdmin(): boolean {
    return this.isRole(MpsRoleHelper.ADMIN);
  }

  isManager(): boolean {
    return this.isRole(MpsRoleHelper.MANAGER);
  }

  isUser(): boolean {
    return this.isRole(MpsRoleHelper.USER);
  }

  isManagerOrAbove(): boolean {
    return this.isAdmin() || this.isManager() || this.isRole(MpsRoleHelper.DELEGATED_MANAGER);
  }

  isRole(roleCode: string): boolean {
    return this.role?.code?.toUpperCase() === roleCode.toUpperCase();
  }
}

export class MpsRole implements MpsIRole {
  id!: number;
  label!: string;
  code!: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
